import { Component, OnInit, OnDestroy, OnChanges, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { number } from 'echarts';
import { ApiService } from '../../../services/api.service';
declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-project-support',
  templateUrl: './project-support.component.html',
  styleUrls: ['./project-support.component.css']
})
export class ProjectSupportComponent implements OnInit {

  geo_province: any
  list_province = [] as any
  list_province_2 = [] as any
  year_start: any
  year_end: any
  sum_project: any
  sum_budget: any
  sum_budget_2: any
  list_funding: any
  list_funding_filter: any
  chart_xAxis = [] as any
  chart_series_1 = [] as any
  chart_series_2 = [] as any
  max_budget = 0
  EChartOption1: any

  xAxis_1 = [] as any
  data_1 = [] as any
  data_2 = [] as any
  data_3 = [] as any
  value_chart_1 = 0
  value_chart_2 = 0
  value_chart_3 = 0
  value_chart_4 = 0
  EChartOption2: any

  group_topic = [] as any

  //progress report
  report_progress = {} as any;
  years = [] as any;
  pdfSrc: any;
  pdf : boolean = false

  constructor(
    public router: Router,
    private services: ApiService
  ) {
    this.services.getYear().then((res: any) => {
      this.view_year(res)
    });
  }

  async ngOnInit() {
    document.getElementById('project-c')!.classList.toggle("active");

    await this.services.getProvince().then((res: any) => {
      this.geo_province = res
    });

    this.services.get_all_funding().then((res: any) => {
      this.list_funding = res
      this.get_data()
      this.initchart(res)
    });
    this.getReport();
  }

  ngOnDestroy() {
    if (document.getElementById('project-c')) {
      document.getElementById('project-c')!.classList.remove("active");
    }
  }

  async view_year(json: any) {
    this.year_start = json[0].fund_year
    this.year_end = json[json.length - 1].fund_year
  }
  async get_data() {
    this.sum_project = this.list_funding.length
    let arr_list_province = [] as any
    let arr_list_province_2 = [] as any
    this.list_funding.forEach((e: any) => {
      if (e.type_money == 'เงินอุดหนุน') {
        this.list_province.push({ name: e.province, value: e.amount_receive, type_money: e.type_money, id: e.project_key })
        arr_list_province.push(Number(e.amount_receive))
      } else if (e.type_money == 'เงินให้กู้ยืม') {
        this.list_province_2.push({ name: e.province, value: e.amount_receive, type_money: e.type_money, id: e.project_key })
        arr_list_province_2.push(Number(e.amount_receive))
      }
    });
    this.sum_budget = arr_list_province.reduce(function (a: any, b: any) {
      return a + b
    }, 0);
    this.sum_budget_2 = arr_list_province_2.reduce(function (a: any, b: any) {
      return a + b
    }, 0);
    let data_budget_year = this.list_funding.reduce(function (r: any, row: any) {
      r[row.fund_year] = ++r[row.fund_year] || 1;
      return r;
    }, {});
    let group_year = Object.keys(data_budget_year).map(function (key) {
      return { name: key, year: data_budget_year[key], budget: 0 }
    }).sort();
    group_year.forEach(e => {
      this.list_funding.forEach((f: any) => {
        if (e.name == f.fund_year) {
          e.budget = Number(e.budget) + Number(f.budget)
        }
      });
    });
    group_year.forEach(e => {
      this.chart_xAxis.push(e.name)
      this.chart_series_1.push(e.year)
      this.chart_series_2.push(e.budget)
    });

    this.max_budget = Math.max.apply(Math, group_year.map(function (o) { return o.budget; }))

    let toSearch = '2563';
    let result_toSearch = this.list_funding.filter((o: any) => o.date_due.includes(toSearch));
    this.list_funding_filter = result_toSearch

    this.services.getIndicators().then((res: any) => {

      let gr_topic = res.reduce(function (r: any, row: any) {
        r[row.topic] = ++r[row.topic] || 1;
        return r;
      }, {});

      this.group_topic = Object.keys(gr_topic).map(function (key) {
        return { topic: key, value: gr_topic[key] };
      }).sort();
    });
  }
  initchart(res: any) {
    let data_budget_year = res.reduce(function (r: any, row: any) {
      r[row.fund_year] = ++r[row.fund_year] || 1;
      return r;
    }, {});
    let group_year = Object.keys(data_budget_year).map(function (key) {
      return { year: key, count: data_budget_year[key], budget_1: 0, budget_2: 0 }
    }).sort();

    group_year.forEach(e => {
      res.forEach((f: any) => {
        if (e.year == f.fund_year && f.type_money == 'เงินให้กู้ยืม') {
          e.budget_1 = e.budget_1 + Number(f.amount_receive)
        } else if (e.year == f.fund_year && f.type_money == 'เงินอุดหนุน') {
          e.budget_2 = e.budget_2 + Number(f.amount_receive)
        }
      });
    });

    group_year.forEach(e => {
      this.xAxis_1.push(e.year)
      this.data_1.push(e.budget_1)
      this.data_2.push(e.budget_2)
      this.data_3.push(e.budget_1 + e.budget_2)
    });


    function format(data: any) {
      data = parseFloat(data);
      return 'เฉลี่ย : ' + data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' บาท'
    }
    //bar chart
    this.EChartOption1 = {
      title: {
        text: '',
        subtext: ''
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow"
        }
      },
      legend: {
        textStyle: {
          fontSize: 12,
          fontFamily: 'Kanit, sans-serif'
        }
      },
      toolbox: {
        show: true,
        feature: {
          dataView: { show: false, readOnly: false },
          magicType: { show: false, type: ['line', 'bar'] },
          restore: { show: false },
          saveAsImage: { show: false }
        }
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: this.xAxis_1,
          axisLabel: {
            formatter: 'ปีงบประมาณ {value}'
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: 'จำนวนเงิน',
          axisLabel: {
            formatter: '{value} บาท'
          }
        },
        {
          type: 'value',
          name: 'จำนวนเงินรวม',
          axisLabel: {
            formatter: '{value} บาท'
          }
        }
      ],
      series: [
        {
          name: 'จำนวนเงินอุดหนุน',
          type: 'bar',
          color: '#198ae3',
          data: this.data_2,
          markPoint: {
            data: [
              { type: 'max', name: 'มากสุด' },
            ],
            label: {
              show: true,
              position: 'insideTop',
              formatter: function (params: any) {
                var val = 'อุดหนุนมากที่สุด : ' + params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' บาท'
                return val;
              }
            }
          },
          markLine: {
            data: [
              { type: 'average', name: 'เฉลี่ยแต่ละปี' }
            ],
            label: {
              show: true,
              formatter: function (params: any) {
                var val = 'เฉลี่ย : ' + params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' บาท'
                return val;
              },
              color: '#198ae3'
            }
          }
        },
        {
          name: 'จำนวนเงินให้กู้ยืม',
          type: 'bar',
          color: '#E91E63',
          data: this.data_1,
          markPoint: {
            data: [
              { type: 'max', name: 'มากสุด' },
            ],
            label: {
              show: true,
              position: 'insideTop',
              formatter: function (params: any) {
                var val = 'กู้ยืมมากที่สุด : ' + params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' บาท'
                return val;
              }
            }
          },
          markLine: {
            data: [
              { type: 'average', name: 'เฉลี่ยแต่ละปี' }
            ],
            label: {
              show: true,
              formatter: function (params: any) {
                var val = 'เฉลี่ย : ' + params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' บาท'
                return val;
              },
              color: '#E91E63'
            }
          }
        },
        {
          name: 'จำนวนเงินรวม',
          type: 'line',
          color: '#FED713',
          yAxisIndex: 1,
          symbolSize: 10,
          lineStyle: {
            width: 3,
            shadowColor: 'rgba(0,0,0,0.4)',
            shadowBlur: 10,
            shadowOffsetY: 10
          },
          data: this.data_3
        }
      ]
    };

    res.forEach((e: any) => {
      if (e.type_money == 'เงินให้กู้ยืม') {
        this.value_chart_1 = this.value_chart_1 + Number(e.budget)
      } else if (e.type_money == 'เงินอุดหนุน') {
        this.value_chart_2 = this.value_chart_2 + Number(e.budget)
      } else if (e.type_money == 'เงินสนับสนุน') {
        this.value_chart_3 = this.value_chart_3 + Number(e.budget)
      } else if (e.type_money == 'เงินทดลองจ่าย') {
        this.value_chart_4 = this.value_chart_4 + Number(e.budget)
      }
    });
    //pie chart
    this.EChartOption2 = {

      title: {
        text: '',
        left: 'center',
        top: 20,
      },

      tooltip: {
        trigger: 'item',
      },

      legend: {
        textStyle: {
          fontSize: 12,
          fontFamily: 'Kanit, sans-serif'
        }
      },
      series: [
        {
          name: 'สัดส่วนเงิน',
          type: 'pie',
          radius: '55%',
          center: ['50%', '50%'],

          data: [
            { value: this.value_chart_2, name: 'เงินอุดหนุน' },
            { value: this.value_chart_1, name: 'เงินให้กู้ยืม' },
            { value: this.value_chart_3, name: 'เงินสนับสนุน' },
            { value: this.value_chart_4, name: 'เงินทดรองจ่าย' }
          ].sort(function (a: any, b: any) { return a.value + b.value; }),

          labelLine: {
            smooth: 0.2,
            length: 10,
            length2: 20
          },
          itemStyle: {
            textStyle: {
              fontSize: 12,
              fontFamily: 'Kanit, sans-serif'
            },
          },

          animationType: 'scale',
          animationEasing: 'elasticOut',
          animationDelay: function (idx: any) {
            return Math.random() * 200;
          },
          color: ['#1bcfb4', '#198ae3', '#fe7c96', '#fed713']

        }
      ]
    }
  }

  async getReport() {
    await this.services.getgprogress().then((res: any) => {
      res.forEach((response: any) => {
        this.years.push(response.years)
      });
      this.years = [...new Set(this.years)].sort();
      this.report_progress = (groupByKey(res, 'years'))
    })

    this.years.forEach((y: any) => {
      let trimas = ['1', '2', '3', '4']

      for (let i = 0; i < this.report_progress[y].length; i++) {
        if (this.report_progress[y].length != 4) {
          this.report_progress[y].forEach((e: any) => {
            for (let j = 0; j <= trimas.length; j++) {
              if (trimas[j] == e.trimas) {
                trimas.splice(j, 1);
              }
            }
          });
          trimas.forEach(element => {
            this.report_progress[y].push({
              id: 0,
              pdf_name: "",
              trimas: element,
              years: ""
            })
          });

        }
      }
      this.report_progress[y] = this.report_progress[y].sort((a: any, b: any) => (a.trimas < b.trimas) ? -1 : ((b.trimas < a.trimas) ? 1 : 0))
      
    });

    function groupByKey(array: any, key: any) {
      return array
        .reduce((hash: any, obj: any) => {
          if (obj[key] === undefined) return hash;
          return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
        }, {})
    }

  }

  pdf_viewer(file_name: any) {
    this.pdf = true
    this.pdfSrc = "https://ogc.mapedia.co.th/api/v1/lrfund/m_file/" + file_name;
  }
  onSave(){
    FileSaver.saveAs(this.pdfSrc);
  }
  onBack(){
    this.pdf = false
  }
}
